module.exports = __webpack_public_path__ + "img/interface OneB Player_6 prew.c4cb9f97.jpg";